<template>
  <div id="wrapper">
    <Nav :message="message" />
    <ReviewReport />
  </div>
</template>
<script>
// @ is an alias to /src
import Nav from '@/components/Nav.vue'
import ReviewReport from '@/components/dashboard/ReviewReport.vue'

export default {
  name: 'Review-Report',
  props: ['message'],
  components: {
    Nav,
    ReviewReport
  }
}
</script>